import { render, staticRenderFns } from "./HolidayLocationsTable.vue?vue&type=template&id=74f7dd52"
import script from "./HolidayLocationsTable.vue?vue&type=script&lang=js"
export * from "./HolidayLocationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports